import Image from "next/image"
import React, { FunctionComponent } from "react"
import useDevice from "hooks/useDevice"

interface Props {
  heading?: string
  subHeading?: string
  hideSubHeading?: boolean
  hideExpertCall?: boolean
}
const Banner: FunctionComponent<Props> = ({
  heading,
  subHeading,
  hideExpertCall,
  hideSubHeading,
}) => {
  const { isMobile } = useDevice()
  return (
    <div className="w-full pt-4">
      <div className="bg-white md:px-8 rounded-[12px] w-full pb-4 md:py-10 shadow-[0px_1px_3px_0px_rgba(16,24,40,0.10),0px_1px_2px_0px_rgba(16,24,40,0.06)] flex flex-col-reverse md:flex-row items-center md:justify-center md:gap-4 md:relative z-20">
        <div className="relative md:static bg-[#F8F8FF] md:bg-white flex justify-center md:justify-end items-center px-4 pt-8 md:pt-0 rounded-t-[8px]  order-[2] w-full md:w-3/5">
          <img
            src={`${process.env.CDN_URL}/assets/icons/liy/expert_mocktest.png`}
            height={isMobile ? 170 : 180}
            width={isMobile ? 190 : 200}
            alt="liy-scholar-logo"
            className="z-20 object-contain"
          />
          <img
            src={
              isMobile
                ? `${process.env.CDN_URL}/assets/icons/liy/bg_mb.svg`
                : `${process.env.CDN_URL}/assets/icons/liy/top_left_icon.svg`
            }
            className="absolute top-0 left-0 md:left-[auto] md:right-0 w-full md:w-auto h-full md:h-auto md:rounded-r-[12px]"
          />
        </div>
        <div className="w-full px-4 md:px-0">
          <div className="text-[#424242] text-[18px] md:text-[26px] pt-4 md:pt-0 text-center md:text-left font-semibold pb-2 md:flex md:justify-start md:items-center md:gap-4">
            {!isMobile && (
              <Image
                src={`${process.env.CDN_URL}/assets/icons/liy/call.svg`}
                width={110}
                height={110}
                alt="call"
              />
            )}
            <div>
              {heading ? heading : "Our IELTS Expert will call you soon!"}
            </div>
          </div>
          {!hideSubHeading && (
            <div className="text-[14px] md:text-[#77768E] md:text-[18px] text-center md:text-left md:pt-4 pb-2">
              {subHeading
                ? subHeading
                : "The expert will create a personalised IELTS preparation plan for you"}
            </div>
          )}
          {!hideExpertCall && (
            <div className="flex justify-center md:justify-start items-center px-4 pt-2 md:pt-4 md:px-0">
              <div className="text-[#0D6008] bg-green-to-light p-2 md:px-4 rounded font-[400]">
                Expect a call in the next 2 hrs
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
export default Banner
